import { InvoicesWorkspace } from "@/features/invoices/components/InvoicesWorkspace";

export function PdfsPage() {
  return (
    <InvoicesWorkspace
      variant="pdfs"
      title="Download Invoice PDFs"
      breadcrumbSuffix="Download Invoice PDFs"
      tableTitle=""
      exportKind="pdf"
      bulkExportCta
      compactDownloadLayout
      hostedLinkActions="open-only"
    />
  );
}
